import { RootState } from 'app/store/rootReducer';

export const isFormSubmitting = (state: RootState) =>
  state.formSubmission.isLoadingResult;
